<button
  (click)="goBack()"
  class="flex items-center justify-center p-1.5 sm:p-2 md:p-2.5 rounded-full bg-gradient-to-r from-yellow-500 to-yellow-500 text-white hover:from-yellow-600 hover:to-yellow-600 transition-all duration-300 shadow-md sm:shadow-lg hover:shadow-xl transform hover:-translate-x-1 active:scale-95 border border-yellow-400 sm:border-2 touch-manipulation"
  aria-label="Volver atrás">
  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 sm:h-5 sm:w-5 md:h-6 md:w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
  </svg>
</button>
